module.exports = __webpack_public_path__ + "img/fa-duotone-900.a721737c.svg";